
import React, { useState } from 'react';
import Tectaks from './Tectaks';
import Newprogram from './Newprogram';
import Carerprogram from './Carerprogram';
import Advertisment from './Advertisment';

const MainComponent = () => {
  const [active, setActive] = useState('three');

  const wrapperStyle = {
    maxHeight: '750px', // Set the scrollable area height as needed
    overflowY: 'auto',
    scrollbarWidth: "none",
      msOverflowStyle: "none",
    
    borderRadius: '10px',
    padding: '0',
    position: 'relative',
  };

  const containerStyle = {
    //  padding: '0px 20px 30px 20px',
    fontFamily: 'sans-serif',
    backgroundColor:"blue"
  };

  const buttonRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    padding: '20px',
    background: 'blue',
    position: 'sticky',
    top: 82,
    zIndex: 10,
    // borderBottom: '1px solid #ddd',
  };

  const buttonStyle = (isActive) => ({
    padding: '10px 20px',
    border: 'none',
    borderRadius: '30px',
    backgroundColor: isActive ? 'orange' : '#e0e0e0',
    color: isActive ? '#fff' : '#000',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: '0.3s',
    minWidth: '100px',
  });

  const boxEStyle = {
    // padding: '63px',
    // margin: '20px auto',
    maxWidth: '1260px',
    textAlign: 'left',
    boxSizing: 'border-box',
    marginTop: '85px',
  };

  const activeboxEStyle = {
    ... boxEStyle,
    borderColor: '#007bff',
  };

  const renderComponent = () => {


    
    switch (active) {
      case 'one':
        return (
          <div style={ boxEStyle}>
            <Tectaks />
            
          </div>
        );
      case 'two':
        return (
          <div style={ boxEStyle}>
            
           <Newprogram/>
          </div>
        );
      case 'three':
        return (
          <div style={activeboxEStyle}>
            <Carerprogram/>
          </div>
        );
      case 'four':
        return (
          <div style={ boxEStyle}>
            <h3>Filter 4</h3>
            <p>This is the fourth filter content.</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div style={wrapperStyle}>
      <div style={containerStyle}>
        

        {/* Scrollable content */}
        {renderComponent()}

         {/* <Advertisment /> */}
      </div>

             <style>
         
       </style>
     
    </div>
  );
};

export default MainComponent;


